import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import FlexWrap from '@/components/common/FlexWrap';
import LoadingView from '@/components/common/LoadingView';
import { useAppDispatch } from '@/hooks/useReduxHooks';
import { ICON_CLOSE_WHITE, ICON_MAXIMIZE, ICON_MINIMIZE } from '@repo/assets';

interface IProps {
  imgUrl: string;
  onTogglePreview?: () => void;
  setIsPreviewModal?: Dispatch<SetStateAction<boolean>>;
}
function ImagePreviewModal({
  imgUrl,
  onTogglePreview,
  setIsPreviewModal,
}: IProps) {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [isRotate, setIsRotate] = useState(false);
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const handleImageLoad = () => {
    setIsLoading(false);
  };
  const onClose = () => {
    dispatch({
      type: 'UPDATE_HOME_MODAL_STATE',
      payload: { type: 'PREVIEW_IMAGE', isActive: false, data: null },
    });
  };

  useEffect(() => {
    const handleBackButton = () => {
      window.history.go(1);
      if (setIsPreviewModal) {
        setIsPreviewModal(false);
      } else {
        onClose();
      }
    };
    window.addEventListener('popstate', handleBackButton);
    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);

  useEffect(() => {
    if (isRotate && scrollRef.current) {
      // 이미지 회전 후 스크롤 맨 위로 이동
      scrollRef.current.scrollLeft = scrollRef.current.scrollWidth;
    }
  }, [isRotate]);

  return (
    <BackContainer
      onClick={() => {
        document.body.style.removeProperty('overflow');
        if (onTogglePreview) {
          onTogglePreview();
        } else {
          onClose();
        }
      }}
    >
      {isRotate ? (
        <WrapperWrapper ref={scrollRef}>
          <VerticalWrapper>
            <VerticalImage src={imgUrl} onLoad={handleImageLoad} />
            <RotateButton
              type='button'
              onClick={(e) => {
                e.stopPropagation();
                setIsRotate(!isRotate);
              }}
            >
              <img src={ICON_MINIMIZE} alt='' width={32} />
            </RotateButton>
          </VerticalWrapper>
        </WrapperWrapper>
      ) : (
        <HorizenWrapper>
          <HorizenImage src={imgUrl} onLoad={handleImageLoad} />
          <RotateButton
            type='button'
            onClick={(e) => {
              e.stopPropagation();
              setIsRotate(!isRotate);
            }}
          >
            <img src={ICON_MAXIMIZE} alt='' width={32} />
          </RotateButton>
        </HorizenWrapper>
      )}
      <CloseImg src={ICON_CLOSE_WHITE} />
      {isLoading && <LoadingView />}
    </BackContainer>
  );
}

export default ImagePreviewModal;

const BackContainer = styled(FlexWrap)`
  position: fixed;
  inset: 0 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0 20px;
  background-color: rgba(58, 59, 62, 0.8);
  z-index: 200;
`;

const HorizenWrapper = styled.div`
  position: relative;
  width: 335px;
  overflow: auto;
`;

const HorizenImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
`;

const WrapperWrapper = styled.div`
  overflow: auto;
`;

const VerticalWrapper = styled.div`
  position: relative;
  transform: rotateZ(90deg);
  width: fit-content;
  height: fit-content;
  padding-bottom: 200px;
`;

const VerticalImage = styled.img`
  display: block;
  width: 70vh;
`;

const RotateButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 999;
`;

const CloseImg = styled.img`
  position: fixed;
  top: 10px;
  right: 10px;
  cursor: pointer;
  width: 35px;
  height: 35px;
`;
